// Hook odpowiedzialny za pobranie ustawień UI (logo, kolory, języki)

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IUiSettings {
  primary_color: string | null;
  secondary_color: string | null;
  logo_file: string | null;
  languages: {
    id: string;
    name: string;
    title_website: string;
    description_website: string;
  }[];
}

// typ zwracanych danych
type IResponse = IUiSettings;

export const getUiSettings = (): Promise<IResponse> => axios.get('/settings');

export const applyUiColors = (data: IResponse) => {
  if (data?.primary_color) {
    document.documentElement.style.setProperty('--color-primary', data.primary_color);
    document.documentElement.style.setProperty('--color-secondary', data.secondary_color || data.primary_color);
  }
};

export const useGetUiSettings = (options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['ui-settings'], () => getUiSettings(), {
    staleTime: 5 * 60 * 1000,
    onSuccess: applyUiColors,
    ...options
  });
